
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
const  Terms = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
  return (
    <>
             <div className="ivo-text-box ivo-section text-center">
        <h2 className="ivo-heading">
            <span className="color_title">Terms </span> And Condition
        </h2>
    </div>

    <section className="ivo-section page-content">
        <div className="container">
            <div className="text-box">
                <h5>Acceptance of Terms</h5>
                <p>Welcome to IVOIRE Tradings! By accessing or using our website and services, you agree to comply with
                    and
                    be bound by the following Terms of Use. Please read these terms carefully before proceeding. If you
                    do
                    not agree with any part of these terms, please refrain from using our website and services.</p>
                <h5>Use of Our Services</h5>
                <p>a. <b>Eligibility</b>: You must be at least 18 years old or the legal age of majority in your
                    jurisdiction to
                    use our services. By using our website and services, you represent and warrant that you meet the
                    eligibility requirements.</p>
                <p> b. <b>Account Registration</b>: To access certain features or services, you may be required to
                    create an
                    account. You are responsible for maintaining the confidentiality of your account information and are
                    solely responsible for all activities that occur under your account.</p>
                <p>c. <b>User Conduct</b>: You agree to use our services in compliance with applicable laws and
                    regulations.
                    You shall not engage in any unlawful, fraudulent, or abusive activities. Furthermore, you agree not
                    to interfere with or disrupt the functioning of our website and services.</p>


                <h5>Intellectual Property</h5>
                <p>a. <b>Ownership</b>: All content, trademarks, logos, and intellectual property displayed on our
                    website are
                    the property of IVOIRE Tradings or its licensors. You are granted a limited, non-exclusive,
                    non-transferable license to access and use our website and services for personal and non-commercial
                    purposes.</p>
                <p> b. <b>Restrictions</b>: You shall not modify, distribute, transmit, display, perform, reproduce,
                    publish,
                    license, create derivative works from, transfer, or sell any content or intellectual property
                    obtained from our website without prior written consent from IVOIRE Tradings.</p>

                <h5>Disclaimer of Warranty</h5>
                <p>a. Our website and services are provided on an "as-is" and "as available" basis. We make no
                    warranties or representations, express or implied, regarding the accuracy, reliability, or
                    completeness of any content or information provided.</p>
                <p>b. You acknowledge that trading involves risks, and we do not provide any investment or financial
                    advice. Any decisions or actions taken based on information obtained from our website are solely at
                    your own risk.</p>

                <h5>Limitation of Liability</h5>
                <p>a. In no event shall IVOIRE Tradings or its affiliates be liable for any direct, indirect,
                    incidental, special, consequential, or punitive damages arising out of or in connection with your
                    use of our website and services, even if we have been advised of the possibility of such damages.
                </p>
                <p>b. We shall not be liable for any losses, damages, or expenses incurred as a result of any
                    interruption, delay, or failure in the operation or provision of our website and services due to
                    circumstances beyond our control.</p>

                <h5>Indemnification</h5>
                <p>You agree to indemnify, defend, and hold harmless IVOIRE Tradings, its directors, officers,
                    employees, and agents from any claims, liabilities, damages, expenses, or costs, including
                    reasonable attorneys' fees, arising out of your use of our website and services or any violation of
                    these Terms of Use.
                </p>


                <h5>Modifications to Terms</h5>
                <p>We reserve the right to modify or update these Terms of Use at any time without prior notice. It is
                    your responsibility to review these terms periodically. Continued use of our website and services
                    after any modifications constitutes acceptance of the revised terms.
                </p>
                <h5>Governing Law and Jurisdiction</h5>
                <p>These Terms of Use shall be governed by and construed in accordance with the laws of <b>Country Name.</b>
                    Any disputes arising out of or in connection with these terms shall be subject to the exclusive
                    jurisdiction of the courts located in <b>City Name.</b>
                </p>
                <h5>Contact Information</h5>
                <p>If you have any questions or concerns regarding these Terms of Use, please contact us at info@ivoiretrading.com

                   
                
                </p>
                <p> By using our website and services, you acknowledge that you</p>

            </div>
        </div>

    </section>
    </>
    );
}

export default Terms;
